import { Columns, Column, Hidden, Stack, Box, Text } from 'braid-design-system';
import type { FC } from 'react';

import Answers from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/Answers';
import NoIcon from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/Icons/NoIcon';
import { RoleRequirementIconWithTooltip } from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/RoleRequirementCredentialTooltip/RoleRequirementIconWithToolTip';
import {
  STATUS_CERTIFIED,
  STATUS_CUSTOM,
} from 'src/constants/roleRequirementStatus';

import * as styles from './RoleRequirement.css';

// FIXME: We are reaching into a different code path for the imports below which is bad.
// However, this is to reduce risk of applying changes that may break. We want to be careful since we are in Jan 2024 Platform Stabilisation.

export interface RoleRequirementProps {
  isMobile?: boolean;
  jobApplicationId: string;
  roleRequirement: {
    question: string;
    status: string;
    showVerifiedTagInAnswers: boolean;
    answers: Array<{ id: string; text: string; isVerified: boolean }>;
    verifications: Array<{
      title: string;
      credentialInfo: Array<{ name: string; values: string[] }>;
    }>;
  };
  hasOnlyCustomQuestions: boolean;
}
export const RoleRequirement: FC<RoleRequirementProps> = ({
  isMobile,
  jobApplicationId,
  roleRequirement: {
    question,
    status,
    showVerifiedTagInAnswers,
    answers,
    verifications,
  },
  hasOnlyCustomQuestions,
}) => {
  const contentOffsetSkillPill = {
    [styles.contentOffsetSkillPill]: showVerifiedTagInAnswers,
  };

  // FIXME: Confirm with PM that we are good to remove this during ANZ launch. This implementation poses a few risks when displaying Certsy verified questions in other languages.
  const verifiedSuffix = status === STATUS_CERTIFIED ? ' verified' : '';

  return (
    <Box data-cy="role-requirement" data-testid={status}>
      <Columns
        space={['xxsmall', 'small']}
        alignY="top"
        align="left"
        collapseBelow="desktop"
      >
        <Column width="1/3">
          <Columns space={['xsmall', 'xsmall', 'none']}>
            {status !== STATUS_CUSTOM ? (
              <Column width="content">
                <Box className={contentOffsetSkillPill}>
                  <Hidden above="tablet">
                    <RoleRequirementIconWithTooltip
                      jobApplicationId={jobApplicationId}
                      verifications={verifications}
                      status={status}
                      isCardView
                      isMobile={isMobile}
                    />
                  </Hidden>
                </Box>
              </Column>
            ) : null}
            <Column>
              <Box className={contentOffsetSkillPill}>
                <Box data-cy="question">
                  <Text
                    tone="neutral"
                    size="small"
                  >{`${question}${verifiedSuffix}`}</Text>
                </Box>
              </Box>
            </Column>
          </Columns>
        </Column>
        {isMobile ? null : (
          <Column width="2/3">
            <Columns space={['xsmall', 'xsmall', 'small']}>
              {!hasOnlyCustomQuestions ? (
                <Column width="content">
                  <Box className={contentOffsetSkillPill}>
                    <Hidden below="desktop">
                      <RoleRequirementIconWithTooltip
                        verifications={verifications}
                        status={status}
                        isCardView
                        isMobile={isMobile}
                        jobApplicationId={jobApplicationId}
                      />
                    </Hidden>
                  </Box>
                  <Hidden above="tablet">
                    <NoIcon />
                  </Hidden>
                </Column>
              ) : null}
              <Column>
                <Stack space="xsmall">
                  <Answers
                    answers={answers}
                    showVerifiedTagInAnswers={showVerifiedTagInAnswers}
                    isCardView
                    verifications={verifications}
                    jobApplicationId={jobApplicationId}
                    status={status}
                    size="small"
                  />
                </Stack>
              </Column>
            </Columns>
          </Column>
        )}
      </Columns>
    </Box>
  );
};
